import React from "react";
import { Edit2, LogOut } from "@piiqtechnologies/svg-icons";
import { TableActionButton } from "@common-components/table";
import { useIntl } from "react-intl";
import messages from "./messages.i18n";
export const UsersActions = ({ onObserve, onEdit, allowProxy }) => {
    const intl = useIntl();
    return [
        React.createElement(TableActionButton, { key: "login-as-user", "aria-label": "observe", onClick: onObserve, Icon: LogOut, disabled: !allowProxy, "data-testid": "user-table-row-proxy", tooltip: intl.formatMessage(messages.actionsObserve) }),
        React.createElement(TableActionButton, { key: "edit-user", "aria-label": "edit", onClick: onEdit, Icon: Edit2, tooltip: intl.formatMessage(messages.actionsEdit) }),
    ];
};
export default UsersActions;
